var path = '/templates/core/views/404.html';
var html = "<div id=error-page><div class=error-number>404</div><div class=error-message>{{ 'sharedModules.core.views.404.pageNotFound' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.404.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/404.html
// module id = 1317
// module chunks = 0